import { useParams, useSearchParams } from "react-router-dom"
import SessionDetailComponent from "../components/sessions/detail/SessionDetailComponent"




export default function SessionPage() {

    let { sessionId } = useParams()
    let [searchParams] = useSearchParams()
    const sensorId = searchParams.get('sensorId')
    
    if (sessionId === undefined) {
        return (
            <h1>Session ID not found</h1>
        )
    }
    
    if (sensorId === null) {
        return (
            <h1>Sensor ID not found</h1>
        )
    }
    
    return (
        <SessionDetailComponent sessionId={sessionId} sensorId={sensorId} />
    )
}